webpackJsonp([1],{

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({ dataUrl: 'https://a.egwwritings.org/cf/', postUrl: 'https://a.egwwritings.org/cf/' });

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    en: {
        msg: {
            name: 'Name',
            email: 'Email',
            message: 'Message',
            add_file: 'Add File',
            send: 'Send',
            select_domain: 'Select site',
            select_subject: 'Select Subject',
            subject: 'Subject',
            thanx: 'Thank you for your feedback'
        }
    },
    ru: {
        msg: {
            name: 'Ф.И.О.',
            email: 'E-mail',
            message: 'Сообщение',
            add_file: 'Прикрепить',
            send: 'Отправить',
            select_domain: 'Выберите сайт',
            select_subject: 'Выберите тему',
            subject: 'Тема',
            thanx: 'Благодарим за Ваш отзыв'
        }
    }
});

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(74)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(75),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        items: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        selectText: {
            type: String,
            default: 'Choose your options'
        },
        value: {
            default: null,
            required: false
        }
    },
    computed: {
        model: function model() {
            return this.value;
        }
    },
    watch: {
        model: function model() {
            this.$el.removeAttribute('onchange');
            this.$nextTick(this.init);
        }
    },
    methods: {
        init: function init() {
            $(this.$el).material_select();

            var vm = this;
            this.$el.onchange = function () {
                vm.$emit('input', this.value);
            };
        }
    },
    mounted: function mounted() {
        this.$nextTick(this.init);
    }
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appconfig_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_promise_polyfill__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_promise_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__select_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_i18n__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lang_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_materials__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_materials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_materials__);



function elem(id) {
    return document.getElementById(id);
}




if (!window.Promise) {
    window.Promise = __WEBPACK_IMPORTED_MODULE_2_promise_polyfill___default.a;
}

if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function value(searchElement, fromIndex) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            var len = o.length >>> 0;

            if (len === 0) {
                return false;
            }

            var n = fromIndex | 0;

            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
            }

            while (k < len) {
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                k++;
            }

            return false;
        }
    });
}

if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';

        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}






__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_i18n___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.config.lang = 'en';


__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_7__lang_data__["a" /* default */]).forEach(function (lang) {
    __WEBPACK_IMPORTED_MODULE_3_vue___default.a.locale(lang, __WEBPACK_IMPORTED_MODULE_7__lang_data__["a" /* default */][lang]);
});


__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_materials___default.a);

function isValidEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function InitApp(exports, domains_data) {
    exports.app = new __WEBPACK_IMPORTED_MODULE_3_vue___default.a({
        el: '#vueapp',
        components: { VSelectMy: __WEBPACK_IMPORTED_MODULE_5__select_vue___default.a },
        data: {
            domainsData: domains_data,
            domain: 'main',
            lang: 'en',
            page: false,
            contact_tag: false,
            form_name: '',
            form_email: '',
            form_message: '',
            isMapEnabled: false,
            mapUrl: null,
            sent: false
        },
        filters: {
            capitalize: function capitalize(s) {
                return s[0].toUpperCase() + s.slice(1);
            }
        },
        computed: {
            domainItems: function domainItems() {
                return this.domainsData.map(function (v) {
                    return { id: v.domain, text: v.name };
                });
            },
            contactItems: function contactItems() {
                var _this = this;

                if (!this.page.contacts) {
                    return [];
                }
                return this.page.contacts.map(function (v) {
                    return { id: v.tag, text: v.name[_this.lang] || v.name.en };
                });
            },
            form_is_valid: function form_is_valid() {
                var v = this.form_name.length > 0 && isValidEmail(this.form_email) && this.form_message.length > 0;
                return v;
            }
        },
        methods: {
            curHash: function curHash(dom, lang) {
                return '#/' + dom + '/' + lang;
            },
            selectLanguage: function selectLanguage(domLangs, lang) {
                var nav = window.navigator;
                var a = [].concat(lang, nav.languages, nav.language, nav.userLanguage);
                var aa = [];
                a.forEach(function (v) {
                    if (!v) {
                        return;
                    }
                    aa.push(v);
                    if (v.includes('-')) {
                        aa.push(v.split('-')[0]);
                    }
                });

                var res = aa.filter(function (v) {
                    return domLangs.includes(v);
                });

                if (res.length) {
                    return res[0];
                }
                return 'en';
            },

            selectDomain: function selectDomain(dom, lang) {
                var t = this.domainsData.filter(function (v) {
                    return v.domain === dom;
                });
                var page = this.page = t.length ? t[0] : this.domainsData[0];
                this.domain = page.domain;
                document.title = page.name;
                this.contact_tag = page.contacts[0].tag;
                __WEBPACK_IMPORTED_MODULE_3_vue___default.a.config.lang = this.lang = this.selectLanguage(page.languages, lang);
                this.isMapEnabled = !!page.map_url;
                if (page.map_url) {
                    this.mapUrl = page.map_url;
                }
            },
            sendForm: function sendForm() {
                var _this2 = this;

                var form = elem('id_form');
                var data = new FormData(form);
                var config = {};
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__appconfig_js__["a" /* default */].postUrl, data, config).then(function (res) {
                    _this2.sent = true;
                }).catch(function (ignore) {});
            },
            domainChanged: function domainChanged() {
                window.location.hash = this.curHash(this.domain, this.lang);
            }
        }
    });
}

function onHashChange() {
    var loc = window.location;

    var p = void 0;
    if (loc.hash) {
        p = loc.hash.replace(/#\/?/, '').split('/');
    } else {
        p = loc.pathname.split('/').slice(1);
    }

    app.selectDomain.apply(app, p);
}
window.addEventListener('hashchange', onHashChange);

$(document).ready(function () {
    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__appconfig_js__["a" /* default */].dataUrl).then(function (res) {
        InitApp(window, res.data);
        onHashChange();
    }).catch(function (res) {});
});

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.selectText))]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id,
        "textContent": _vm._s(item.text)
      }
    })
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ })

},[46]);


// WEBPACK FOOTER //
// static/js/app.815234d55db6ddcc3802.js